
import { defineComponent, PropType, watch } from 'vue'
import { Product } from '../../../types'
import { isEmpty } from "lodash";

export default defineComponent({
  name: 'YieldRow',
  props: {
    products: {
      type: Array as PropType<Product[]>
    },
    rowId: {
      type: Number
    },
    values: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({})
    },
    result: {
      type: Object as PropType<Record<string, number>[]>,
      default: () => ({})
    },
    showAdjustColumn: {
      type: Boolean,
      default: true
    }
  },
  emits: ['rowUpdate'],
  computed: {
    filteredProducts(): Array<Product> {
      if (this.products) {
        const filteredProducts = this.products.filter((product) => isEmpty(product.bond) == false)
        return this.sortProducts(filteredProducts)
      } else {
        return []
      }
    }
  },
  methods: {
    sortProducts(products: any) {
      return products.sort((a: any, b: any) => {
        // Handle null or undefined 'ord_s' by assigning them a high sort value
        const ordA = a.ord_s == null ? Number.MAX_SAFE_INTEGER : a.ord_s;
        const ordB = b.ord_s == null ? Number.MAX_SAFE_INTEGER : b.ord_s;

        if (ordA !== ordB) {
          return ordA - ordB;
        }
        // If 'ord_s' is the same, sort by product 'name'
        return a.name.localeCompare(b.name);
      });
    },
    updateRow(event: Event) {
      const target = event.target as HTMLInputElement
      const value = target.type === 'checkbox' ? target.checked : target.value; // Handle checkbox input type
      this.$emit('rowUpdate', { row: this.rowId, name: target.name, value: value })
    },
    initValue(event: Event) {
      const target = event.target as HTMLInputElement
      if (target.value === '') {
        target.value = '0'
        this.$emit('rowUpdate', { row: this.rowId, values: [{ name: target.name, value: target.value }] })
      }
    }
  }
})
